import fontawesome from '@fortawesome/fontawesome';

import faBars from '@fortawesome/fontawesome-free-solid/faBars.js';
import faDownload from '@fortawesome/fontawesome-free-solid/faDownload.js';
import faPlus from '@fortawesome/fontawesome-free-solid/faPlus.js';
import faMinus from '@fortawesome/fontawesome-free-solid/faMinus.js';
import faTimes from '@fortawesome/fontawesome-free-solid/faTimes.js';
import faChevronUp from '@fortawesome/fontawesome-free-solid/faChevronUp.js';
import faChevronDown from '@fortawesome/fontawesome-free-solid/faChevronDown.js';
import faChevronLeft from '@fortawesome/fontawesome-free-solid/faChevronLeft.js';
import faChevronRight from '@fortawesome/fontawesome-free-solid/faChevronRight.js';
import faTrashAlt from '@fortawesome/fontawesome-free-solid/faTrashAlt.js';
import faExclamationTriangle from '@fortawesome/fontawesome-free-solid/faExclamationTriangle.js';
import faAngleDown from '@fortawesome/fontawesome-free-solid/faAngleDown.js';
import faAngleLeft from '@fortawesome/fontawesome-free-solid/faAngleLeft.js';
import faAngleRight from '@fortawesome/fontawesome-free-solid/faAngleRight.js';
import faFile from '@fortawesome/fontawesome-free-solid/faFile.js';
import faTag from '@fortawesome/fontawesome-free-solid/faTag.js';
import faInfoCircle from '@fortawesome/fontawesome-free-solid/faInfoCircle.js';
import faArrowLeft from '@fortawesome/fontawesome-free-solid/faArrowLeft.js';
import faArrowRight from '@fortawesome/fontawesome-free-solid/faArrowRight.js';
import faHistory from '@fortawesome/fontawesome-free-solid/faHistory.js';
import faUndoAlt from '@fortawesome/fontawesome-free-solid/faUndoAlt.js';
import faRedoAlt from '@fortawesome/fontawesome-free-solid/faRedoAlt.js';
import faEdit from '@fortawesome/fontawesome-free-solid/faEdit.js';
import faFilePdf from '@fortawesome/fontawesome-free-solid/faFilePdf.js';
import faExclamationCircle from '@fortawesome/fontawesome-free-solid/faExclamationCircle.js';
import faTimesCircle from '@fortawesome/fontawesome-free-solid/faTimesCircle.js';
import faCheckCircle from '@fortawesome/fontawesome-free-solid/faCheckCircle.js';
import faCircle from '@fortawesome/fontawesome-free-solid/faCircle.js';
import faCheck from '@fortawesome/fontawesome-free-solid/faCheck.js';
import faQuestion from '@fortawesome/fontawesome-free-solid/faQuestion.js';
import faQuestionCircle from '@fortawesome/fontawesome-free-solid/faQuestionCircle.js';

/* Include fontawesome icons */
fontawesome.library.add({
  faBars,
  faDownload,
  faFile,
  faFilePdf,
  faChevronUp,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faTrashAlt,
  faExclamationTriangle,
  faExclamationCircle,
  faCircle,
  faCheck,
  faTimesCircle,
  faCheckCircle,
  faAngleDown,
  faAngleLeft,
  faAngleRight,
  faTag,
  faTimes,
  faPlus,
  faMinus,
  faInfoCircle,
  faArrowLeft,
  faArrowRight,
  faHistory,
  faUndoAlt,
  faRedoAlt,
  faEdit,
  faQuestion,
  faQuestionCircle,
});
